import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbButtonModule, NbIconModule, NbTooltipModule } from '@nebular/theme';
import { MostrarTutorialComponent } from './mostrar-tutorial.component';

@NgModule({
  imports: [
    CommonModule,
    NbButtonModule,
    NbIconModule,
    NbTooltipModule,
  ],
  declarations: [
    MostrarTutorialComponent,
  ],
  exports: [
    MostrarTutorialComponent,
  ],
})
export class MostrarTutorialModule { } 